// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__G2Ryl","heading":"Logo_heading__HjaYA","span":"Logo_span__Q+Mgh"};